<template>
<svg :width="width" :height="height" viewBox="0 0 24 27" :fill="color" xmlns="http://www.w3.org/2000/svg">
<path d="M11.0102 0.264222C11.6227 -0.0880741 12.3773 -0.0880741 12.9897 0.264222L23.0103 6.02815C23.6227 6.38045 24 7.0315 24 7.73609V19.2639C24 19.9685 23.6227 20.6196 23.0103 20.9719L12.9897 26.7358C12.3773 27.0881 11.6227 27.0881 11.0102 26.7358L0.989741 20.9719C0.377289 20.6196 0 19.9685 0 19.2639V7.73609C0 7.0315 0.377289 6.38045 0.989741 6.02815L11.0102 0.264222Z"  fill-opacity="0.3"/>
<path d="M19.1244 13.6906L8.62436 19.7528V7.62842L19.1244 13.6906Z" fill="white"/>
</svg>

</template>

<script>
export default {
    props: {
        width: { type: [Number, String], default: 24 },
        height: { type: [Number, String], default: 27 },
        color: { type: String, default: "#D3D4DE" }
    }
}
</script>
